import styled from 'styled-components';

const FooterTitle = styled.span`
   margin-right: 15px;
`;

export default FooterTitle;